var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlineImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 858,
    height: 517,
    viewBox: "0 0 858 517",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5889 476.941H816.412",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5889 427.931H816.412",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5889 452.437H83.8752",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.258 452.437H188.544",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.927 452.437H293.214",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.597 452.437H397.883",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.266 452.437H502.553",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.936 452.437H607.222",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.605 452.437H711.892",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.275 452.437H816.564",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.742 192.044V427.931H349.269V192.044",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.179 192.044H526.021V180.807H470.107",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.905 180.807H341.991V192.044H399.833",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.107 180.807H520.129V169.568H468.179",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.833 169.568H347.883V180.807H397.905",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.107 180.807C470.107 200.01 453.944 215.578 434.006 215.578C414.067 215.578 397.905 200.01 397.905 180.807C397.905 161.603 414.067 146.035 434.006 146.035C453.944 146.035 470.107 161.603 470.107 180.807Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.529 176.244H438.742V162.002H429.269V176.244H414.482V185.368H429.269V199.61H438.742V185.368H453.529V176.244Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.258 224.107V237.647H396.446V232.038H391.526V237.647H388.714V224.107H391.526V229.813H396.446V224.107H399.258Z",
    fill: "#33516D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.096 226.041C406.389 226.041 404.883 227.492 404.883 230.877C404.883 234.262 406.389 235.713 408.096 235.713C409.803 235.713 411.31 234.262 411.31 230.877C411.31 227.492 409.803 226.041 408.096 226.041ZM408.096 238.034C404.682 238.034 401.97 235.423 401.97 230.877C401.97 226.331 404.682 223.72 408.096 223.72C411.51 223.72 414.221 226.331 414.221 230.877C414.221 235.423 411.51 238.034 408.096 238.034Z",
    fill: "#33516D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.469 233.682C425.469 236.1 423.461 238.034 420.046 238.034C417.135 238.034 415.628 236.293 415.628 236.293L416.833 234.455C416.833 234.455 417.938 235.713 419.846 235.713C421.653 235.713 422.557 234.842 422.557 233.682C422.557 231.264 416.231 232.521 416.231 227.782C416.231 225.557 418.139 223.72 421.051 223.72C423.862 223.72 425.168 225.267 425.168 225.267L424.064 227.105C424.064 227.105 422.959 226.041 421.252 226.041C419.946 226.041 419.143 226.815 419.143 227.782C419.143 230.296 425.469 229.136 425.469 233.682Z",
    fill: "#33516D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.793 226.331V231.167H433.103C434.307 231.167 435.311 230.2 435.311 228.749C435.311 227.299 434.307 226.331 433.103 226.331H430.793ZM430.793 237.647H427.981V224.107H433.103C436.316 224.107 438.223 225.945 438.223 228.749C438.223 231.554 436.316 233.391 433.103 233.391H430.793V237.647Z",
    fill: "#33516D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.546 237.647H440.734V224.107H443.546V237.647Z",
    fill: "#33516D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.797 224.107V226.331H452.182V237.647H449.371V226.331H445.756V224.107H455.797Z",
    fill: "#33516D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.526 227.685H462.426L460.819 232.618H464.133L462.526 227.685ZM459.112 237.647H456.2L460.719 224.107H464.234L468.752 237.647H465.84L464.937 234.939H460.016L459.112 237.647Z",
    fill: "#33516D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.561 224.107H473.373V235.423H479.297V237.647H470.561V224.107Z",
    fill: "#33516D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.046 259.417H408.966V248.068H459.046V259.417Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.042 259.417H419.97V248.068H448.042V259.417Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.042 280.781H419.97V269.431H448.042V280.781Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.042 302.144H419.97V290.795H448.042V302.144Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.042 323.507H419.97V312.158H448.042V323.507Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.042 344.871H419.97V333.521H448.042V344.871Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.443 259.417H481.226V248.068H469.443V259.417Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.161 259.417H502.945V248.068H491.161V259.417Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.067 259.417H376.851V248.068H365.067V259.417Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.786 259.417H398.569V248.068H386.786V259.417Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.046 280.781H408.966V269.431H459.046V280.781Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.443 280.781H481.226V269.431H469.443V280.781Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.161 280.781H502.945V269.431H491.161V280.781Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.067 280.781H376.851V269.431H365.067V280.781Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.786 280.781H398.569V269.431H386.786V280.781Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.046 302.144H408.966V290.795H459.046V302.144Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.443 302.144H481.226V290.795H469.443V302.144Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.161 302.144H502.945V290.795H491.161V302.144Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.067 302.144H376.851V290.795H365.067V302.144Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.786 302.144H398.569V290.795H386.786V302.144Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.046 323.507H408.966V312.158H459.046V323.507Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.443 323.507H481.226V312.158H469.443V323.507Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.161 323.507H502.945V312.158H491.161V323.507Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.067 323.507H376.851V312.158H365.067V323.507Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.786 323.507H398.569V312.158H386.786V323.507Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.046 344.871H408.966V333.521H459.046V344.871Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.908 295.569H170.452V284.219H188.908V295.569Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.142 295.569H163.218V284.219H196.142V295.569Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.696 295.569H217.239V284.219H235.696V295.569Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.929 295.569H210.005V284.219H242.929V295.569Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.483 295.569H264.026V284.219H282.483V295.569Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.716 295.569H256.792V284.219H289.716V295.569Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.27 295.569H310.813V284.219H329.27V295.569Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.503 295.569H303.579V284.219H336.503V295.569Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.443 344.871H481.226V333.521H469.443V344.871Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.161 344.871H502.945V333.521H491.161V344.871Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.067 344.871H376.851V333.521H365.067V344.871Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.786 344.871H398.569V333.521H386.786V344.871Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.305 366.735H388.706V360.503H479.305V366.735Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.929 427.931H393.083V366.734H474.929V427.931Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.975 208.401V238.034",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.755 217.877V238.034",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.037 208.401V238.034",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.257 217.877V238.034",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.006 366.734V427.931",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.082 393.439V401.784",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.93 393.439V401.784",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.644 373.745L399.175 379.975",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.739 373.745L400.143 388.766",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.595 421.433L468.064 415.201",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.501 421.433L467.097 406.412",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.168 427.931H364.519V405.456H377.168V427.931Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.143 405.456H381.544",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.168 405.456L364.547 417.612",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.168 415.775L364.547 427.931",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.547 405.456L377.168 417.612",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.547 415.775L377.168 427.931",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.742 265.592H518.743V277.943H710.742V265.592Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.779 256.58H549.414V265.593H676.779V256.58Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.007 277.943V395.24",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.083 291.684V298.194",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.083 314.884V321.393",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.083 338.083V344.592",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.083 361.282V367.792",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.083 384.482V390.991",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.067 282.366V286.455",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.999 282.366V285.37",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.931 282.366V283.534",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.862 282.366V283.534",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.901 304.682H534.078V294.918H546.901V304.682Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.588 304.682H560.765V294.918H573.588V304.682Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.273 304.682H587.45V294.918H600.273V304.682Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.959 304.682H614.136V294.918H626.959V304.682Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.645 304.682H640.822V294.918H653.645V304.682Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.901 327.798H534.078V318.034H546.901V327.798Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.588 327.798H560.765V318.034H573.588V327.798Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.273 327.798H587.45V318.034H600.273V327.798Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.959 327.798H614.136V318.034H626.959V327.798Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.645 327.798H640.822V318.034H653.645V327.798Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.901 350.914H534.078V341.15H546.901V350.914Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.588 350.914H560.765V341.15H573.588V350.914Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.273 350.914H587.45V341.15H600.273V350.914Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.959 350.914H614.136V341.15H626.959V350.914Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.645 350.914H640.822V341.15H653.645V350.914Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.157 427.931H518.743V277.943H704.157V427.931Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.901 372.124H534.078V362.361H546.901V372.124Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.588 372.124H560.765V362.361H573.588V372.124Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.273 372.124H587.45V362.361H600.273V372.124Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.645 372.124H640.822V362.361H653.645V372.124Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.901 395.24H534.078V385.476H546.901V395.24Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.588 395.24H560.765V385.476H573.588V395.24Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.645 395.24H640.822V385.476H653.645V395.24Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.479 360.503V420.31",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.053 391.603V420.31",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.111 405.956H589.616",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.111 410.463H589.616",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.865 416.805H593.862",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.569 402.34V427.931",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.158 402.34V427.931",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.451 405.956H687.956",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.451 410.463H687.956",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.205 416.805H692.202",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.909 402.34V427.931",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.498 402.34V427.931",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.136 362.361V366.101C615.776 367.386 617.286 369.496 618.599 372.124H626.959V362.361H614.136Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.805 385.476C623.397 388.766 623.727 392.113 623.727 395.24H626.959V385.476H622.805Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.45 385.476V395.24H597.501C597.501 392.113 597.831 388.766 598.423 385.476H587.45Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.727 395.24C623.727 408.513 617.856 412.791 610.614 412.791C603.372 412.791 597.501 408.513 597.501 395.24C597.501 381.966 603.372 364.723 610.614 364.723C617.856 364.723 623.727 381.966 623.727 395.24Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.614 393.772V427.931",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.614 399.921L605.848 396.665",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.909 407.681L615.676 402.34",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.182 395.24C746.182 408.513 740.311 412.791 733.075 412.791C725.831 412.791 719.96 408.513 719.96 395.24C719.96 381.966 725.831 364.723 733.075 364.723C740.311 364.723 746.182 381.966 746.182 395.24Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.46 376.436C739.563 379.203 740.45 382.387 741.067 385.638C741.684 388.89 742.023 392.207 742.023 395.239",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.676 376.436C616.776 379.203 617.667 382.387 618.283 385.638C618.9 388.89 619.241 392.207 619.241 395.239",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.075 393.772V427.931",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.075 399.921L728.306 396.665",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.366 407.681L738.135 402.34",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.732 395.24C793.732 408.513 787.861 412.791 780.618 412.791C773.381 412.791 767.51 408.513 767.51 395.24C767.51 381.966 773.381 364.723 780.618 364.723C787.861 364.723 793.732 381.966 793.732 395.24Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.618 393.772V427.931",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.617 399.921L775.855 396.665",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.916 407.681L785.684 402.34",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.204 376.436C787.306 379.203 788.2 382.387 788.817 385.638C789.434 388.89 789.774 392.207 789.774 395.239",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4906 395.24C90.4906 408.513 84.6204 412.791 77.3784 412.791C70.1365 412.791 64.2661 408.513 64.2661 395.24C64.2661 381.966 70.1365 364.723 77.3784 364.723C84.6204 364.723 90.4906 381.966 90.4906 395.24Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3784 393.772V427.931",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3781 399.921L72.6113 396.665",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6729 407.681L82.4396 402.34",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4395 376.436C83.5395 379.203 84.4309 382.387 85.0478 385.638C85.664 388.89 86.0057 392.207 86.0057 395.239",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.828 71.7193C558.504 71.7193 556.317 72.2781 554.395 73.2555C554.426 72.7628 554.442 72.2514 554.442 71.7193C554.442 54.2321 539.724 40.0561 521.569 40.0561C508.077 40.0561 496.49 47.8871 491.424 59.0835C488.482 56.2188 484.399 54.443 479.885 54.443C470.921 54.443 463.654 61.4422 463.654 70.0756C463.654 71.4763 463.848 72.8322 464.206 74.124C461.967 72.6126 459.245 71.7193 456.302 71.7193C448.678 71.7193 442.497 77.6723 442.497 85.0153C442.497 92.359 448.678 98.312 456.302 98.312H560.828C568.452 98.312 574.633 92.359 574.633 85.0153C574.633 77.6723 568.452 71.7193 560.828 71.7193Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.353 69.1843C469.353 64.7114 473.117 61.0856 477.76 61.0856",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.695 85.5347C447.695 81.0624 451.459 77.4366 456.103 77.4366",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.386 58.7764C502.39 46.7949 516.532 40.9887 528.971 45.8081",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.376 121.46C111.858 121.46 114.192 122.057 116.243 123.099C116.21 122.573 116.192 122.028 116.192 121.46C116.192 102.794 131.903 87.6616 151.283 87.6616C165.684 87.6616 178.052 96.0207 183.46 107.972C186.601 104.915 190.959 103.019 195.777 103.019C205.345 103.019 213.102 110.489 213.102 119.705C213.102 121.2 212.895 122.647 212.513 124.026C214.904 122.413 217.809 121.46 220.95 121.46C229.088 121.46 235.686 127.814 235.686 135.652C235.686 143.491 229.088 149.846 220.95 149.846H109.376C101.238 149.846 94.6401 143.491 94.6401 135.652C94.6401 127.814 101.238 121.46 109.376 121.46Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.02 118.754C207.02 113.979 203.002 110.109 198.045 110.109",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.137 136.207C230.137 131.433 226.119 127.562 221.163 127.562",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.463 108.019C170.458 96.0369 156.317 90.2314 143.877 95.0508",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.941 133.561C699.145 133.561 701.218 134.091 703.041 135.018C703.006 134.55 702.992 134.066 702.992 133.561C702.992 116.98 716.952 103.539 734.163 103.539C746.958 103.539 757.945 110.963 762.748 121.58C765.535 118.864 769.409 117.179 773.686 117.179C782.184 117.179 789.081 123.816 789.081 132.002C789.081 133.33 788.894 134.616 788.554 135.841C790.675 134.408 793.26 133.561 796.047 133.561C803.276 133.561 809.14 139.205 809.14 146.168C809.14 153.131 803.276 158.776 796.047 158.776H696.941C689.71 158.776 683.849 153.131 683.849 146.168C683.849 139.205 689.71 133.561 696.941 133.561Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.674 131.157C783.674 126.916 780.105 123.478 775.703 123.478",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.212 146.661C804.212 142.42 800.642 138.982 796.234 138.982",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.501 123.478C752.497 111.497 738.356 105.69 725.915 110.51",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.978 163.337H179.126",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4683 163.337H107.732",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.176 178.247H216.324",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.602 178.247H144.931",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.842 68.8401H274.693",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.351 68.8401H346.087",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.643 53.9304H237.495",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.217 53.9304H308.889",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.521 112.653H513.179",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.807 112.653H567.908",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.005 127.562H484.663",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.675 127.562H539.392",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.618 174.228H751.956",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.329 174.228H697.226",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.133 189.138H780.472",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.461 189.138H725.742",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.915 225.349H274.063",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.872 225.349H639.02",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.572 225.349H202.67",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 225.349H567.627",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.254 117.495H329.105",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.596 117.495H400.499",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.113 240.258H311.262",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.07 240.258H676.219",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.54 240.258H239.868",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.497 240.258H604.825",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.262 253.742H719.96",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.318 253.742H764.467",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.664 269.394H794.966",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.608 269.394H750.459",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0262 319.612H55.7231",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.08 319.612H100.23",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7524 304.703H138.207",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5254 304.703H84.5489",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.453 382.597V275.106H349.269V427.931H150.453V419.306",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.269 304.682H150.453V275.106H349.269V304.682Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.908 333.18H170.452V321.831H188.908V333.18Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.142 333.18H163.218V321.831H196.142V333.18Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.696 333.18H217.239V321.831H235.696V333.18Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.929 333.18H210.005V321.831H242.929V333.18Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.483 333.18H264.026V321.831H282.483V333.18Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.716 333.18H256.792V321.831H289.716V333.18Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.27 333.18H310.813V321.831H329.27V333.18Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.503 333.18H303.579V321.831H336.503V333.18Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.269 312.158H150.453V304.682H349.269V312.158Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.269 349.77H150.453V342.294H349.269V349.77Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.269 265.593H141.5V275.106H349.269V265.593Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.132 258.249H148.258V265.593H171.132V258.249Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.483 323.991L752.49 326.921",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.177 331.049L748.22 331.044",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.504 338.083V335.154",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.809 331.026L756.767 331.031",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.179 289.639L792.186 293.864",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.65 299.817L786.038 299.81",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.214 309.961L792.207 305.736",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.749 299.783L798.362 299.791",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.525 167.715L563.532 171.381",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.386 176.546L558.192 176.54",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.556 185.349L563.549 181.683",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.695 176.517L568.888 176.523",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8193 61.0857L97.8256 64.7522",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6792 69.9175L92.4859 69.9114",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.849 78.7197L97.8428 75.0539",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.988 69.888L103.182 69.894",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.131 153.185L287.137 156.852",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.992 162.017L281.798 162.011",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.162 170.819L287.155 167.153",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.301 161.988L292.495 161.994",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0195 249.182L78.0272 253.438",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4102 259.434L71.8292 259.427",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0548 269.653L78.0479 265.397",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6649 259.4L84.2461 259.407",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.484 215.856L122.489 218.632",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.565 222.542L118.447 222.538",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.507 229.207L122.502 226.431",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.426 222.521L126.545 222.525",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.466 64.2403L637.473 67.6304",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.014 72.4077L632.535 72.4017",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.495 80.5483L637.488 77.1576",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.947 72.3802L642.426 72.3862",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.502 64.2529L775.509 66.9226",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.848 70.6831L771.621 70.6784",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.523 77.0916V74.4225",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.177 70.6618L779.404 70.6665",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.5 427.931H256.792V362.284H317.5V427.931Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.662 362.284H325.631",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.826 382.597V362.284H228.533V427.931H167.826V420.29",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.694 362.284H236.664",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.884 419.307H196.893V382.597H126.424L111.637 407.855V419.307H122.577",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.212 419.307H171.323",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.966 401.434L129.258 387.27H145.716V401.434H120.966Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.716 382.597H132.835V378.341H145.716V382.597Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.828 378.341H135.724V373.952C135.724 372.062 137.314 370.53 139.276 370.53C141.238 370.53 142.828 372.062 142.828 373.952V378.341Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.834 401.434H155.16V387.27H171.834V401.434Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.211 420.361C138.211 424.542 134.693 427.931 130.352 427.931C126.011 427.931 122.492 424.542 122.492 420.361C122.492 416.18 126.011 412.791 130.352 412.791C134.693 412.791 138.211 416.18 138.211 420.361Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.352 423.259C128.693 423.259 127.344 421.958 127.344 420.361C127.344 418.764 128.693 417.464 130.352 417.464C132.011 417.464 133.36 418.764 133.36 420.361C133.36 421.958 132.011 423.259 130.352 423.259Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.963 420.361C186.963 424.542 183.444 427.931 179.102 427.931C174.761 427.931 171.242 424.542 171.242 420.361C171.242 416.18 174.761 412.791 179.102 412.791C183.444 412.791 186.963 416.18 186.963 420.361Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.102 423.259C177.444 423.259 176.094 421.958 176.094 420.361C176.094 418.764 177.444 417.464 179.102 417.464C180.761 417.464 182.111 418.764 182.111 420.361C182.111 421.958 180.761 423.259 179.102 423.259Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.063 393.097H186.298V390.433C186.298 389.74 185.715 389.178 184.994 389.178C184.275 389.178 183.691 389.74 183.691 390.433V393.097H180.926C180.206 393.097 179.623 393.659 179.623 394.352C179.623 395.045 180.206 395.607 180.926 395.607H183.691V398.271C183.691 398.964 184.275 399.526 184.994 399.526C185.715 399.526 186.298 398.964 186.298 398.271V395.607H189.063C189.783 395.607 190.366 395.045 190.366 394.352C190.366 393.659 189.783 393.097 189.063 393.097Z",
    fill: "#33516D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.749 414.969H111.637V411.381H116.749V414.969Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.894 414.969H191.782V408.877H196.894V414.969Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.276 364.926V359.641",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.473 366.743L130.247 362.467",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.886 371.497L124.667 369.864",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.666 371.497L153.884 369.864",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.079 366.743L148.304 362.467",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.661 403.62H236.665V384.426H248.661V403.62Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.742 394.023C244.742 395.129 243.811 396.026 242.663 396.026C241.514 396.026 240.583 395.129 240.583 394.023C240.583 392.917 241.514 392.02 242.663 392.02C243.811 392.02 244.742 392.917 244.742 394.023Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.836 371.408V415.201",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.438 388.766V415.201",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.414 419.307H263.878V407.855H310.414V419.307Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.444 419.307H279.85V414.746H294.444V419.307Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.72 382.584H270.909L263.878 407.854H310.414L302.72 382.584Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.587 382.597H280.706V378.341H293.587V382.597Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.698 378.341H283.594V373.952C283.594 372.062 285.185 370.53 287.146 370.53C289.108 370.53 290.698 372.062 290.698 373.952V378.341Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.878 427.931H266.957V419.306H272.878V427.931Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.691 427.931H301.77V419.306H307.691V427.931Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.106 415.83H263.878V410.811H274.106V415.83Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.415 415.83H300.187V410.811H310.415V415.83Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.511 400.767L273.622 385.989H300.073L304.573 400.767H269.511Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.502 397.781V400.475H308.302",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.992 397.781H260.59V391.837H262.992V397.781Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.703 397.781H311.3V391.837H313.703V397.781Z",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.791 397.781V400.475H265.991",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.826 368.96H228.533",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.826 375.636H228.533",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.826 382.312H228.533",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.073 388.988H228.533",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.073 395.664H228.533",
    stroke: "#33516D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineImg);
export default __webpack_public_path__ + "static/media/outline-img.433011b3af0b5ab402cec337f4db916d.svg";
export { ForwardRef as ReactComponent };